import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { safeStorage, THEME_KEY } from "./api/storage";
import "@fontsource-variable/archivo/wdth.css";
import "leaflet/dist/leaflet.css";
import "./styles.css";

const theme = safeStorage.get(THEME_KEY);
if (theme === "light" || theme === "dark") document.documentElement.dataset.theme = theme;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Installable PWA: cache the app shell only (never API data). Production builds only.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  });
}
